var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _vm.toolTip
        ? _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                class: _vm.classStyle,
                                attrs: {
                                  to: _vm.to,
                                  target: _vm.target,
                                  disabled: _vm.disabled,
                                  loading: _vm.loading,
                                  icon: "",
                                  "aria-label": _vm.ariaLabel || _vm.toolTip,
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(
                              "span",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      small:
                                        _vm.small ||
                                        (!_vm.cancelAutoSmall &&
                                          _vm.$vuetify.breakpoint.name != "xs"),
                                      color: _vm.color,
                                      "aria-hidden": "true",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.$emit("click")
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.icon))]
                                ),
                                _vm.textButton
                                  ? _c("small", [
                                      _c("br"),
                                      _vm._v(_vm._s(_vm.textButton)),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1737139441
              ),
            },
            [_c("span", [_vm._v(_vm._s(_vm.toolTip))])]
          )
        : _c(
            "v-btn",
            {
              class: _vm.classStyle,
              attrs: {
                to: _vm.to,
                target: _vm.target,
                disabled: _vm.disabled,
                loading: _vm.loading,
                icon: "",
                "aria-label": _vm.ariaLabel || "Ação",
              },
            },
            [
              _c(
                "span",
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        small:
                          _vm.small ||
                          (!_vm.cancelAutoSmall &&
                            _vm.$vuetify.breakpoint.name != "xs"),
                        color: _vm.color,
                        "aria-hidden": "true",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.$emit("click")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.icon))]
                  ),
                  _vm.textButton
                    ? _c("small", [_c("br"), _vm._v(_vm._s(_vm.textButton))])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }